function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-s2-1{fill:#123856;}.cls-s2-2{fill:#f4c156;}.cls-s2-3{fill:#c09233;}.cls-s2-4{fill:#eb3825;}.cls-s2-5{fill:#cb2b27;}.cls-s2-6{fill:#2e536b;}.cls-s2-7{fill:#49697e;}.cls-s2-8{fill:#748a9c;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "s2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "s2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-s2-1",
  x: 947.46,
  y: 518.92,
  width: 104.17,
  height: 31.44
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-2",
  d: "M1153.76,649.88c.4,0,.79,0,1.18,0a18.58,18.58,0,0,0,18.66-17.39,94.22,94.22,0,0,1,3.08-19.6A79.92,79.92,0,0,1,1190,585.57c8.66-11.53,20.74-21.34,36.36-29.59a18.21,18.21,0,0,0,7.56-25,19.1,19.1,0,0,0-25.56-7.51c-29.76,15.72-50.47,36.56-61.95,62.25a119.77,119.77,0,0,0-8.41,27.33,139.82,139.82,0,0,0-2,17.34A18.71,18.71,0,0,0,1153.76,649.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-2",
  d: "M1518.43,555c15.74,8.14,28,17.87,36.81,29.34A80.36,80.36,0,0,1,1569,611.57a96,96,0,0,1,3.39,19.58,18.76,18.76,0,0,0,18.92,17.26c.4,0,.79,0,1.18,0A18.5,18.5,0,0,0,1610,628.76a137.38,137.38,0,0,0-2.31-17.32,120.88,120.88,0,0,0-8.83-27.27c-11.88-25.61-32.92-46.31-62.92-61.82a19,19,0,0,0-25.45,7.68A18.34,18.34,0,0,0,1518.43,555Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-3",
  d: "M1510.48,530a18.34,18.34,0,0,0,8,25c15.74,8.14,28,17.87,36.81,29.34l43.61-.15c-11.88-25.61-32.92-46.31-62.92-61.82A19,19,0,0,0,1510.48,530Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-3",
  d: "M1146.4,585.72l43.59-.15c8.66-11.53,20.74-21.34,36.36-29.59a18.21,18.21,0,0,0,7.56-25,19.1,19.1,0,0,0-25.56-7.51C1178.59,539.19,1157.88,560,1146.4,585.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-4",
  d: "M943.18,199.65l51.07,169.92L1037.07,512c8.77,29.16,36.17,49.18,67.18,49.08l503.57-1.73c31-.11,58.09-20.32,66.4-49.53l11.56-40.66,50.08-176.08-61.88.22c-38.19.13-71.68,24.76-82.41,60.6-29.15,71.91-281.53,89-348.15,1.2,0,0,85.2-100.21-36.41-143.16S943.18,199.65,943.18,199.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-5",
  d: "M994.25,369.57,1037.07,512c8.77,29.16,36.17,49.18,67.18,49.08l503.57-1.73c31-.11,58.09-20.32,66.4-49.53l11.56-40.66c-17.36,26.42-50.66,62-113.49,65.18C1414.35,542.4,1081.41,529.6,994.25,369.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-2",
  d: "M934.14,212.66h0A10.77,10.77,0,0,0,946.49,220c28.37-5.41,78.83-12.23,109.19-12.33,54.71-.19,103.48,7.14,144.93,21.78,28.92,10.22,46.12,24.36,51.12,42,7.69,27.2-14,60.94-23,71.61h0a18.35,18.35,0,0,0-.61,23.05h0c32.1,42.28,103.93,67.33,192.17,67h0c79.55-.28,168.83-22.76,188.93-72.37l.33-.8.24-.82A65.27,65.27,0,0,1,1634,325.14,67.69,67.69,0,0,1,1674.12,312l61.75-.21A9.44,9.44,0,0,0,1745,305h0a9.4,9.4,0,0,0-9.24-11.86l-61.75.21c-38.19.13-71.68,24.75-82.42,60.61-29.13,71.89-281.52,88.95-348.14,1.19,0,0,85.66-101.51-36.42-143.15-108.56-37-227.81-19.43-264.65-12.51A10.43,10.43,0,0,0,934.14,212.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-2",
  d: "M1734.52,666.18,942,671.88A16.19,16.19,0,0,1,925.6,656a16,16,0,0,1,16.14-16l792.53-5.71c14.4-.05,25.92-3.9,33.32-11.13A32,32,0,0,0,1777,599.7c-.15-19.53-15.06-39.26-43.26-39.16a16.18,16.18,0,0,1-16.39-15.87,16,16,0,0,1,16.14-16c49-.17,75.77,36.4,76,70.9a63.19,63.19,0,0,1-18.88,46.2C1781.15,655,1763.73,666.08,1734.52,666.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-6",
  d: "M930.49,545.72c-2.55,10-15.68,15.8-29.37,13s-22.74-13.21-20.2-23.22,15.7-15.8,29.39-13S933,535.71,930.49,545.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-6",
  d: "M896.29,532.89c-5.3,21-32.49,33.21-60.7,27.38s-46.79-27.51-41.48-48.47,32.53-33.22,60.72-27.39S901.61,511.92,896.29,532.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-6",
  d: "M860.54,501.67c-9.7,40.77-60,64.46-112.26,52.91s-86.82-54-77.13-94.7,60-64.48,112.27-52.93S870.25,460.9,860.54,501.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-6",
  d: "M226.81,459.06c-.82,51-52.26,91.51-114.89,90.48S-.81,506.34,0,455.36s52.27-91.52,114.89-90.5S227.64,408.06,226.81,459.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-6",
  d: "M475.06,449.21c-.86,54.49-55.81,97.76-122.73,96.67S231.9,499.73,232.79,445.25s55.82-97.76,122.73-96.67S476,394.73,475.06,449.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-6",
  d: "M851.63,335.7C850.89,382.1,804.08,419,747.11,418s-102.58-39.31-101.83-85.71S692.83,249.07,749.82,250,852.39,289.3,851.63,335.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-6",
  d: "M711,459.37c-1,58.51-60,105-131.8,103.83s-129.34-49.57-128.4-108.08,60-105,131.81-103.82S711.91,400.86,711,459.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-6",
  d: "M795.56,418.82c-.94,57.32-58.74,102.86-129.14,101.71S539.73,472,540.65,414.66,599.4,311.82,669.78,313,796.47,361.51,795.56,418.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-6",
  d: "M353.49,434.78c-.91,56.41-57.81,101.23-127.08,100.09S101.72,487.09,102.62,430.69,160.43,329.46,229.7,330.6,354.39,378.37,353.49,434.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-6",
  d: "M812.94,223.56c-.61,37.56-38.49,67.39-84.6,66.64s-83-31.81-82.4-69.36,38.48-67.39,84.59-66.64S813.55,186,812.94,223.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-7",
  d: "M253.74,333.05c-.82,51-52.26,91.51-114.89,90.49S26.13,380.34,27,329.34s52.26-91.51,114.88-90.48S254.56,282.05,253.74,333.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-7",
  d: "M335.68,396.39c-.82,51-52.27,91.52-114.89,90.49s-112.72-43.19-111.91-94.19,52.26-91.51,114.89-90.49S336.5,345.39,335.68,396.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-7",
  d: "M511.07,364.57C510,429.69,444.34,481.41,364.39,480.11S220.45,425,221.51,359.85,288.23,243,368.18,244.32,512.12,299.46,511.07,364.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-7",
  d: "M744.73,367.69c-1,63.17-64.73,113.36-142.31,112.09S462.77,426.28,463.8,363.1,528.53,249.75,606.1,251,745.74,304.51,744.73,367.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-7",
  d: "M753.26,251.86C752.43,303.79,700,345,636.28,344s-114.77-44-113.94-95.91,53.2-93.17,117-92.13S754.1,199.94,753.26,251.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-7",
  d: "M762.81,134.55c-.83,51.93-53.2,93.18-117,92.15s-114.79-44-114-95.92,53.22-93.17,117-92.13S763.65,82.62,762.81,134.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-8",
  d: "M374,324.18c-.73,45.83-47,82.24-103.24,81.32s-101.32-38.82-100.58-84.65,47-82.25,103.25-81.33S374.79,278.34,374,324.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-8",
  d: "M366.28,162.06c-.74,46.35-47.49,83.17-104.42,82.25s-102.45-39.26-101.71-85.62,47.5-83.16,104.42-82.24S367,115.71,366.28,162.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-8",
  d: "M293,248.73c-.72,44.9-46,80.57-101.15,79.67s-99.25-38-98.53-82.93,46-80.58,101.14-79.67S293.75,203.82,293,248.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-8",
  d: "M500.49,95.17c-.6,38.14-39.07,68.44-85.91,67.67s-84.31-32.29-83.69-70.44S370,24,416.8,24.73,501.12,57,500.49,95.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-8",
  d: "M688.45,152.45c-.61,38.15-39.08,68.44-85.92,67.68s-84.31-32.31-83.69-70.45S557.92,81.24,604.76,82,689.07,114.31,688.45,152.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-8",
  d: "M549,276.22c-1,65.11-66.72,116.84-146.69,115.53S258.43,336.6,259.48,271.49,326.2,154.65,406.17,156,550.08,211.11,549,276.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-8",
  d: "M683.89,292.26c-.92,56.41-57.81,101.23-127.08,100.1S432.11,344.57,433,288.16s57.8-101.22,127.08-100.09S684.8,235.84,683.89,292.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-8",
  d: "M600.51,162.42c-.91,56.41-57.8,101.23-127.07,100.1S348.75,214.74,349.65,158.33,407.45,57.1,476.73,58.24,601.42,106,600.51,162.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-s2-8",
  d: "M629.75,69.38c-.61,37.55-38.48,67.38-84.59,66.63s-83-31.81-82.41-69.36S501.24-.74,547.35,0,630.37,31.82,629.75,69.38Z"
})));

var SvgS2 = function SvgS2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1809.49 671.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgS2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/s2.622af20c.svg";
export { ForwardRef as ReactComponent };